// Comprehensive Multilingual Translation Engine & Dictionary for Turon University Portal
// Languages: 'uz' (New Latin: õ, ğ, ş, ç), 'ru' (Русский), 'en' (English)

// Transliteration: Official Latin -> New Proposed Latin (õ, ğ, ş, ç)
export function toNewLatin(text) {
  if (!text || typeof text !== 'string') return text;
  return text
    // Sh / sh
    .replace(/SH/g, 'Ş')
    .replace(/Sh/g, 'Ş')
    .replace(/sh/g, 'ş')
    // Ch / ch
    .replace(/CH/g, 'Ç')
    .replace(/Ch/g, 'Ç')
    .replace(/ch/g, 'ç')
    // Oʻ / oʻ (all Unicode apostrophes: U+02BB, U+02BC, U+2018, U+2019, U+0027, etc.)
    .replace(/O[ʻ'’‘`ʼ´ʽʹ]/g, 'Õ')
    .replace(/o[ʻ'’‘`ʼ´ʽʹ]/g, 'õ')
    // Gʻ / gʻ
    .replace(/G[ʻ'’‘`ʼ´ʽʹ]/g, 'Ğ')
    .replace(/g[ʻ'’‘`ʼ´ʽʹ]/g, 'ğ');
}

// Normalize apostrophes for dictionary lookup
export function normalizeKey(str) {
  if (!str || typeof str !== 'string') return '';
  return str
    .replace(/[ʻ'’‘`ʼ´ʽʹ]/g, "'")
    .replace(/\s+/g, ' ')
    .trim();
}

// Master Phrase & Sentence Dictionary
export const PHRASES = {
  "Bo'lim nomi": {
    ru: "Наименование отдела",
    en: "Department Name"
  },
  "Ilmiy tadqiqotlar va doktorantura bo'limi": {
    ru: "Отдел научных исследований и докторантуры",
    en: "Scientific Research and Doctoral Studies Department"
  },
  "Aloqa ma'lumotlari": {
    ru: "Контактная информация",
    en: "Contact Information"
  },
  "Kim foydalanishi mumkin": {
    ru: "Кому доступно",
    en: "Who can use"
  },
  "Huquqiy asos": {
    ru: "Правовая основа",
    en: "Legal Basis"
  },
  "Hujjatlar qabul qilish muddati:": {
    ru: "Срок приема документов:",
    en: "Document submission deadline:"
  },
  "Imtihon tartibi:": {
    ru: "Порядок проведения экзамена:",
    en: "Examination procedure:"
  },
  "Imtihonga oid yangiliklar uchun Telegram kanal:": {
    ru: "Telegram-канал для новостей об экзамене:",
    en: "Telegram channel for examination updates:"
  },
  "To'lov uchun rekvizitlar:": {
    ru: "Реквизиты для оплаты:",
    en: "Payment Requisites:"
  },
  "Tashkilot:": {
    ru: "Организация:",
    en: "Organization:"
  },
  "Manzil:": {
    ru: "Адрес:",
    en: "Address:"
  },
  "ShXRa:": {
    ru: "Лицевой счет (Л/С):",
    en: "Personal Account:"
  },
  "STIR / INN:": {
    ru: "ИНН:",
    en: "TIN:"
  },
  "G'azna:": {
    ru: "Казначейство:",
    en: "Treasury:"
  },
  "Moliya vazirligi G'aznachiligi": {
    ru: "Казначейство Министерства финансов",
    en: "Ministry of Finance Treasury"
  },
  "Hisob raqam:": {
    ru: "Расчетный счет:",
    en: "Account number:"
  },
  "MFO:": {
    ru: "МФО:",
    en: "MFO:"
  },
  "Murojaat uchun aloqa:": {
    ru: "Контакты для обращений:",
    en: "Contact for Inquiries:"
  },
  "Telefon:": {
    ru: "Телефон:",
    en: "Phone:"
  },
  "Ish vaqti:": {
    ru: "Режим работы:",
    en: "Working Hours:"
  },
  "09:00 – 17:00 (Dushanba – Juma)": {
    ru: "09:00 – 17:00 (Понедельник – Пятница)",
    en: "09:00 – 17:00 (Monday – Friday)"
  },
  "Xizmat sharhlari": {
    ru: "Отзывы о сервисе",
    en: "Service Reviews"
  },
  "Tushunarli": {
    ru: "Понятно",
    en: "Understood"
  },
  "Hujjat qabulining boshlanish sanasi": {
    ru: "Дата начала приема документов",
    en: "Application opening date"
  },
  "Hujjat qabulining oxirgi tugash muddati": {
    ru: "Окончательный срок приема документов",
    en: "Application closing date"
  },
  "Xizmatdan foydalanish (Ko'rish)": {
    ru: "Воспользоваться услугой (Просмотр)",
    en: "Use Service (Preview)"
  },
  "30 kun": {
    ru: "30 дней",
    en: "30 days"
  },
  "Tahrirlash": {
    ru: "Редактировать",
    en: "Edit"
  },
  "O'chirish": {
    ru: "Удалить",
    en: "Delete"
  },
  "Ushbu sharhni tahrirlash": {
    ru: "Редактировать этот отзыв",
    en: "Edit this review"
  },
  "Ushbu sharhni o'chirish": {
    ru: "Удалить этот отзыв",
    en: "Delete this review"
  },
  "Chet tilidan va...": {
    ru: "Квалификационный экзамен...",
    en: "Qualifying exam..."
  },
  "Ochish →": {
    ru: "Открыть →",
    en: "Open →"
  },
  "Ochish": {
    ru: "Открыть",
    en: "Open"
  },
  "Yopish ✕": {
    ru: "Закрыть ✕",
    en: "Close ✕"
  },
  "✕ Yopish": {
    ru: "✕ Закрыть",
    en: "✕ Close"
  },
  "ta xizmat": {
    ru: "услуг",
    en: "services"
  },
  "ta soha": {
    ru: "направлений",
    en: "departments"
  },
  "ta mos elektron xizmat": {
    ru: "соответствующих электронных услуг",
    en: "matching electronic services"
  },
  "Maxsus imtihon - Davlat va jamiyat qurilishi tizimini takomillashtirish, qonun ustuvorligi, iqtisodiyotni rivojlantirish va liberallashtirish hamda ijtimoiy rivojlanishning ilmiy asoslari va amaliy yo'nalishlari": {
    ru: "Специальный экзамен - Научные основы и практические направления совершенствования государственного и общественного строительства, верховенства закона, развития и либерализации экономики, социального развития",
    en: "Special Examination - Scientific Foundations and Practical Directions of State and Society Building, Rule of Law, Economic Development and Liberalization, and Social Development"
  },
  "Xorijiy til (ingliz tili)": {
    ru: "Иностранный язык (английский язык)",
    en: "Foreign language (English language)"
  },
  "Xorijiy til (nemis tili)": {
    ru: "Иностранный язык (немецкий язык)",
    en: "Foreign language (German language)"
  },
  "Xorijiy til (fransuz tili)": {
    ru: "Иностранный язык (французский язык)",
    en: "Foreign language (French language)"
  },
  "Xorijiy til (rus tili)": {
    ru: "Иностранный язык (русский язык)",
    en: "Foreign language (Russian language)"
  },
  "Xorijiy til (xitoy tili)": {
    ru: "Иностранный язык (китайский язык)",
    en: "Foreign language (Chinese language)"
  },
  "Xorijiy til (arab tili)": {
    ru: "Иностранный язык (арабский язык)",
    en: "Foreign language (Arabic language)"
  },
  "Xorijiy til (ispan tili)": {
    ru: "Иностранный язык (испанский язык)",
    en: "Foreign language (Spanish language)"
  },
  "01.01.01 - Matematik analiz": {
    ru: "01.01.01 - Математический анализ",
    en: "01.01.01 - Mathematical Analysis"
  },
  "01.01.02 - Differensial tenglamalar va matematik fizika": {
    ru: "01.01.02 - Дифференциальные уравнения и математическая физика",
    en: "01.01.02 - Differential Equations and Mathematical Physics"
  },
  "01.04.04 - Fizik elektronika": {
    ru: "01.04.04 - Физическая электроника",
    en: "01.04.04 - Physical Electronics"
  },
  "01.04.10 - Yarimo'tkazgichlar fizikasi": {
    ru: "01.04.10 - Физика полупроводников",
    en: "01.04.10 - Semiconductor Physics"
  },
  "01.04.11 - Lazer fizikasi": {
    ru: "01.04.11 - Лазерная физика",
    en: "01.04.11 - Laser Physics"
  },
  "03.00.05 - Botanika": {
    ru: "03.00.05 - Ботаника",
    en: "03.00.05 - Botany"
  },
  "03.00.08 - Odam va hayvonlar fiziologiyasi": {
    ru: "03.00.08 - Физиология человека и животных",
    en: "03.00.08 - Human and Animal Physiology"
  },
  "05.05.06 - Qayta tiklanadigan energiya turlari asosidagi energiya qurilmalari": {
    ru: "05.05.06 - Энергетические установки на основе возобновляемых источников энергии",
    en: "05.05.06 - Energy Installations Based on Renewable Energy Sources"
  },
  "07.00.01 - O'zbekiston tarixi": {
    ru: "07.00.01 - История Узбекистана",
    en: "07.00.01 - History of Uzbekistan"
  },
  "07.00.07 - Etnografiya, etnologiya va antropologiya": {
    ru: "07.00.07 - Этнография, этнология и антропология",
    en: "07.00.07 - Ethnography, Ethnology and Anthropology"
  },
  "08.00.05 - Xizmat ko'rsatish tarmoqlari iqtisodiyoti": {
    ru: "08.00.05 - Экономика сферы услуг",
    en: "08.00.05 - Service Sector Economics"
  },
  "08.00.06 - Ekonometrika va statistika": {
    ru: "08.00.06 - Эконометрика и статистика",
    en: "08.00.06 - Econometrics and Statistics"
  },
  "08.00.11 - Marketing": {
    ru: "08.00.11 - Маркетинг",
    en: "08.00.11 - Marketing"
  },
  "08.00.12 - Mintaqaviy iqtisodiyot": {
    ru: "08.00.12 - Региональная экономика",
    en: "08.00.12 - Regional Economics"
  },
  "08.00.13 - Menejment": {
    ru: "08.00.13 - Менеджмент",
    en: "08.00.13 - Management"
  },
  "08.00.17 - Turizm va mehmonxona faoliyati": {
    ru: "08.00.17 - Туризм и гостиничная деятельность",
    en: "08.00.17 - Tourism and Hotel Management"
  },
  "10.00.01 - O'zbek tili": {
    ru: "10.00.01 - Узбекский язык",
    en: "10.00.01 - Uzbek Language"
  },
  "10.00.02 - O'zbek mumtoz adabiyoti": {
    ru: "10.00.02 - Узбекская классическая литература",
    en: "10.00.02 - Uzbek Classical Literature"
  },
  "10.00.06 - Qiyosiy adabiyotshunoslik va tarjimashunoslik": {
    ru: "10.00.06 - Сравнительное литературоведение и переводоведение",
    en: "10.00.06 - Comparative Literature and Translation Studies"
  },
  "13.00.01 - Pedagogika nazariyasi. Pedagogik ta'limotlar tarixi": {
    ru: "13.00.01 - Теория педагогики. История педагогических учений",
    en: "13.00.01 - Educational Theory. History of Pedagogical Thought"
  },
  "13.00.02 - Ta'lim va tarbiya nazariyasi hamda metodikasi (sohalar bo'yicha)": {
    ru: "13.00.02 - Теория и методика обучения и воспитания (по отраслям)",
    en: "13.00.02 - Theory and Methods of Teaching and Education (by fields)"
  },
  "13.00.06 - Raqamli ta'lim nazariyasi va metodikasi (ta'lim sohalari va bosqichlari bo'yicha)": {
    ru: "13.00.06 - Теория и методика цифрового образования (по областям и этапам образования)",
    en: "13.00.06 - Digital Education Theory and Methodology (by stages and areas)"
  },
  "13.00.07 - Ta'limda menejment": {
    ru: "13.00.07 - Менеджмент в образовании",
    en: "13.00.07 - Management in Education"
  },
  "Adabiyotshunoslik": {
    ru: "Литературоведение",
    en: "Literary Studies"
  },
  "Amaliy ekonometrika": {
    ru: "Прикладная эконометрика",
    en: "Applied Econometrics"
  },
  "Analitik mexanikaning tanlangan boblari": {
    ru: "Избранные главы аналитической механики",
    en: "Selected Chapters of Analytical Mechanics"
  },
  "Areal lingvistika": {
    ru: "Ареальная лингвистика",
    en: "Areal Linguistics"
  },
  "Biznesda raqamli boshqarish": {
    ru: "Цифровое управление в бизнесе",
    en: "Digital Management in Business"
  },
  "Dorivor o'simliklarni introduksiyasi va akklimatizatsiyasi": {
    ru: "Интродукция и акклиматизация лекарственных растений",
    en: "Introduction and Acclimatization of Medicinal Plants"
  },
  "Ekonometrika-2": {
    ru: "Эконометрика-2",
    en: "Econometrics-2"
  },
  "Globallashuv sharoitida O'zbekiston va Jahon mamlakatlari hamkorligi": {
    ru: "Сотрудничество Узбекистана и стран мира в условиях глобализации",
    en: "Cooperation of Uzbekistan and World Countries in the Context of Globalization"
  },
  "Ijtimoiy-iqtisodiy jarayonlarni modellashtirish va prognozlash": {
    ru: "Моделирование и прогнозирование социально-экономических процессов",
    en: "Modeling and Forecasting of Socio-Economic Processes"
  },
  "Jahon adabiyoti muammolari": {
    ru: "Проблемы мировой литературы",
    en: "Problems of World Literature"
  },
  "Kognitiv psixologiya": {
    ru: "Когнитивная психология",
    en: "Cognitive Psychology"
  },
  "Lingvokulturologiya va matn tilshunosligi": {
    ru: "Лингвокультурология и лингвистика текста",
    en: "Linguoculturology and Text Linguistics"
  },
  "Mahalliy va mintaqaviy rivojlanish iqtisodiyoti": {
    ru: "Экономика местного и регионального развития",
    en: "Economics of Local and Regional Development"
  },
  "Materiallar strukturasi va strukturaviy tahlil": {
    ru: "Структура материалов и структурный анализ",
    en: "Material Structure and Structural Analysis"
  },
  "Mikrob biotexnologiya": {
    ru: "Микробная биотехнология",
    en: "Microbial Biotechnology"
  },
  "Xizmatga baho va sharh qoldirish": {
    ru: "Оставить оценку и отзыв о сервисе",
    en: "Leave a rating and review for this service"
  },
  "Xizmatga baho va sharh qoldirish uchun avval shaxsiy kabinetingizga kiring.": {
    ru: "Для того чтобы оставить оценку и отзыв, пожалуйста, войдите в личный кабинет.",
    en: "To leave a rating and review, please log in to your personal cabinet first."
  },
  "Xizmatdan mamnunlik darajangiz (baho):": {
    ru: "Уровень удовлетворенности сервисом (оценка):",
    en: "Your satisfaction level with service (rating):"
  },
  "Izoh yoki sharhingiz:": {
    ru: "Ваш комментарий или отзыв:",
    en: "Your comment or review:"
  },
  "Administrator ko'rish rejimi": {
    ru: "Режим просмотра администратора",
    en: "Administrator view mode"
  },
  "Tizimdan chiqish (Talabgor sifatida ariza topshirish)": {
    ru: "Выйти из системы (Подать заявку как соискатель)",
    en: "Log out (Submit application as applicant)"
  },
  "Talabgor sharhini tahrirlash": {
    ru: "Редактировать отзыв соискателя",
    en: "Edit applicant review"
  },
  "Talabgor F.I.Sh.:": {
    ru: "Ф.И.О. соискателя:",
    en: "Applicant Full Name:"
  },
  "Baho (1 dan 5 gacha yulduz):": {
    ru: "Оценка (от 1 до 5 звезд):",
    en: "Rating (1 to 5 stars):"
  },
  "Sharh matni:": {
    ru: "Текст отзыва:",
    en: "Review text:"
  },
  "Saqlash va reytingni yangilash": {
    ru: "Сохранить и обновить рейтинг",
    en: "Save and update rating"
  },
  "Arizangiz muvaffaqiyatli qabul qilindi!": {
    ru: "Ваша заявка успешно принята!",
    en: "Your application has been successfully submitted!"
  },
  "Belgilangan fan nomi": {
    ru: "Название выбранного предмета",
    en: "Assigned Subject Name"
  },
  "Fayl yuklash": {
    ru: "Загрузить файл",
    en: "Upload File"
  },
  "Shaxsiy ma'lumotlar": {
    ru: "Личные данные",
    en: "Personal Information"
  },
  "Ariza berish": {
    ru: "Подать заявление",
    en: "Submit Application"
  },
  "Administrator hisobi: Ariza topshirish cheklangan": {
    ru: "Учетная запись администратора: подача заявок ограничена",
    en: "Administrator account: Application submission is restricted"
  },

  "Asosan ochiq": {
    ru: "Преимущественно ясно",
    en: "Mostly clear"
  },
  "Qisman bulutli": {
    ru: "Переменная облачность",
    en: "Partly cloudy"
  },
  "Tumanli": {
    ru: "Туман",
    en: "Foggy"
  },
  "Mayda yomg'ir": {
    ru: "Моросящий дождь",
    en: "Drizzle"
  },
  "Kuchli jala": {
    ru: "Ливень",
    en: "Heavy rain"
  },
  "Qor yog'moqda": {
    ru: "Идет снег",
    en: "Snowing"
  },
  "Kuchli qor": {
    ru: "Снегопад",
    en: "Heavy snow"
  },
  "Momaqaldiroq": {
    ru: "Гроза",
    en: "Thunderstorm"
  },
  "Qarshi": {
    ru: "Карши",
    en: "Karshi"
  },
  "Toshkent": {
    ru: "Ташкент",
    en: "Tashkent"
  },
  "Samarqand": {
    ru: "Самарканд",
    en: "Samarkand"
  },
  "Buxoro": {
    ru: "Бухара",
    en: "Bukhara"
  },
  "Namangan": {
    ru: "Наманган",
    en: "Namangan"
  },
  "Andijon": {
    ru: "Андижан",
    en: "Andijan"
  },
  "Farg'ona": {
    ru: "Фергана",
    en: "Fergana"
  },
  "Nukus": {
    ru: "Нукус",
    en: "Nukus"
  },
  "Urganch": {
    ru: "Ургенч",
    en: "Urgench"
  },
  "Termiz": {
    ru: "Термез",
    en: "Termez"
  },
  "Jizzax": {
    ru: "Джизак",
    en: "Jizzakh"
  },
  "Navoiy": {
    ru: "Навои",
    en: "Navoi"
  },
  "Guliston": {
    ru: "Гулистан",
    en: "Gulistan"
  },
  "Shahrisabz": {
    ru: "Шахрисабз",
    en: "Shahrisabz"
  },
  "Turon Universiteti • Rasmiy ta'lim portali": {
    ru: "Университет Турон • Официальный образовательный портал",
    en: "Turon University • Official Educational Portal"
  },
  "Turon universiteti yagona interaktiv xizmatlar portali": {
    ru: "Единый портал интерактивных услуг Университета Турон",
    en: "Turon University Unified Interactive Services Portal"
  },
  "Universitetning barcha elektron ta'lim va ilmiy xizmatlari, onlayn arizalar qabuli hamda natijalarni monitoring qilishning yagona rasmiy platformasi.": {
    ru: "Единая официальная платформа для всех электронных образовательных и научных услуг, онлайн-подачи заявок и мониторинга результатов.",
    en: "Single official platform for all electronic educational and scientific services, online application submissions, and results tracking."
  },
  "Imtihonga ariza topshirish": {
    ru: "Подать заявку на экзамен",
    en: "Apply for Examination"
  },
  "Mening arizalarim holati": {
    ru: "Статус моих заявок",
    en: "Status of My Applications"
  },
  "Yo'riqnoma": {
    ru: "Инструкция",
    en: "Guidelines"
  },
  "Barcha xizmatlar katalogi": {
    ru: "Каталог всех услуг",
    en: "All Services Catalog"
  },
  "Portal haqida": {
    ru: "О портале",
    en: "About Portal"
  },
  "Qidiruv natijasi": {
    ru: "Результаты поиска",
    en: "Search Results"
  },
  "Faol foydalanuvchilar": {
    ru: "Активные пользователи",
    en: "Active Users"
  },
  "Bo'limlar va sektorlar": {
    ru: "Отделы и секторы",
    en: "Departments and Sectors"
  },
  "Interaktiv elektron xizmatlar": {
    ru: "Интерактивные электронные услуги",
    en: "Interactive E-Services"
  },
  "Katalog": {
    ru: "Каталог",
    en: "Catalog"
  },
  "Elektron xizmatlar": {
    ru: "Электронные услуги",
    en: "Electronic Services"
  },
  "Universitetning barcha ta'lim, ilmiy va ma'muriy yo'nalishdagi onlayn xizmatlari.": {
    ru: "Все онлайн-услуги университета по образовательным, научным и административным направлениям.",
    en: "All online services of the university in educational, scientific, and administrative areas."
  },
  "Xizmatlarni ko'rish": {
    ru: "Просмотреть услуги",
    en: "View Services"
  },
  "Topshirilgan arizalarning joriy holati, komissiya xulosasi va rasmiy qaydnomani ko'rish.": {
    ru: "Просмотр текущего статуса поданных заявок, заключения комиссии и официальной ведомости.",
    en: "View the current status of submitted applications, commission decision, and official transcript."
  },
  "Sifat nazorati": {
    ru: "Контроль качества",
    en: "Quality Control"
  },
  "So'rovnomalar": {
    ru: "Опросы",
    en: "Surveys"
  },
  "Ta'lim sifati va ilmiy jarayonlar bo'yicha o'z fikr-mulohazalaringizni bildiring.": {
    ru: "Выскажите свое мнение и отзывы о качестве образования и научных процессах.",
    en: "Share your feedback and thoughts on education quality and scientific processes."
  },
  "Qatnashish": {
    ru: "Участвовать",
    en: "Participate"
  },
  "24/7 Qo'llab-quvvatlash": {
    ru: "Поддержка 24/7",
    en: "24/7 Support"
  },
  "Texnik yordam": {
    ru: "Техническая помощь",
    en: "Technical Support"
  },
  "Tizim bo'yicha savollar, muammolar va maslahatlar uchun universitet aloqa markazi.": {
    ru: "Контакт-центр университета по вопросам, техническим проблемам и консультациям.",
    en: "University contact center for questions, technical issues, and consultations."
  },
  "Bog'lanish": {
    ru: "Связаться",
    en: "Contact"
  },
  "Qidiruv so'zini to'g'ri kiritganingizni tekshiring yoki quyidagi bo'limlar orqali xizmatlarni ko'ring.": {
    ru: "Проверьте правильность поискового запроса или найдите нужную услугу по разделам ниже.",
    en: "Check your search query or browse services through the departments below."
  },
  "Tuzilma va yo'nalishlar": {
    ru: "Структура и направления",
    en: "Structure and Departments"
  },
  "Universitet bo'limlari va sohalari": {
    ru: "Отделы и направления университета",
    en: "University Departments and Sectors"
  },
  "Xizmatdan foydalanish": {
    ru: "Воспользоваться услугой",
    en: "Use Service"
  },
  "Talab yuqori xizmatlar": {
    ru: "Востребованные услуги",
    en: "High-Demand Services"
  },
  "Yangi imkoniyatlar": {
    ru: "Новые возможности",
    en: "New Opportunities"
  },
  "Eng yangi raqamli xizmatlar": {
    ru: "Новейшие цифровые услуги",
    en: "Newest Digital Services"
  },
  "Hujjat topshirishning oxirgi muddatiga qoldi:": {
    ru: "До окончания срока подачи документов осталось:",
    en: "Time remaining until deadline:"
  },
  "Ushbu xizmat bo'yicha arizalar qabul qilish muddati yakunlangan": {
    ru: "Прием заявок по данной услуге завершен",
    en: "Application deadline for this service has passed"
  },
  "ariza qoldirish uchun yetarli": {
    ru: "достаточно для подачи заявки",
    en: "enough time to apply"
  },
  "marotaba foydalanilgan": {
    ru: "раз использовано",
    en: "times used"
  },
  "Mehmon": {
    ru: "Гость",
    en: "Guest"
  },
  "Talaba": {
    ru: "Студент",
    en: "Student"
  },
  "Xodim": {
    ru: "Сотрудник",
    en: "Employee"
  },
  "Haqida": {
    ru: "О сервисе",
    en: "About"
  },
  "Joriy yilning noyabr oyida ilmiy tadqiqotchilar uchun chet tili (ingliz tili) va mutaxassislik fanlari bo'yicha malakaviy imtihonlar o'tkazilishi rejalashtirilgan.": {
    ru: "В ноябре текущего года запланировано проведение квалификационных экзаменов по иностранному языку (английский) и специальным предметам для научных исследователей.",
    en: "In November of this year, qualifying examinations in foreign languages (English) and specialty subjects are scheduled for researchers."
  },
  "+ Baho va sharh qoldirish": {
    ru: "+ Оставить оценку и отзыв",
    en: "+ Leave a rating and review"
  },
  "Hozircha sharhlar qoldirilmagan. Ushbu xizmat bo'yicha birinchi bo'lib o'z fikr va bahoingizni qoldiring!": {
    ru: "Отзывов пока нет. Будьте первым, кто оставит свой отзыв и оценку по этой услуге!",
    en: "No reviews yet. Be the first to share your opinion and rating for this service!"
  },
  "+ Fikr va baho bildirish": {
    ru: "+ Оставить отзыв и оценку",
    en: "+ Leave feedback and rating"
  },
  "Admin boshqaruv paneliga o'tish": {
    ru: "Перейти в панель администратора",
    en: "Go to Admin Panel"
  },
  "Barcha arizalar monitoringi, komissiya natijalari va muddatlarni boshqarish paneli.": {
    ru: "Панель мониторинга всех заявок, результатов комиссии и управления сроками.",
    en: "Dashboard for application monitoring, committee results, and deadline management."
  },
  "Administrator rejimi": {
    ru: "Режим администратора",
    en: "Administrator Mode"
  },
  "Ish joyidan ma'lumotnoma va mehnat daftarchasidan ko'chirma olish": {
    ru: "Получение справки с места работы и выписки из трудовой книжки",
    en: "Obtaining employment certificate and extract from labor record book"
  },
  "Universitet Rektori shaxsiy qabuliga yozilish": {
    ru: "Запись на личный прием к Ректору университета",
    en: "Appointment for personal reception with University Rector"
  },
  "Rektor nomiga rasmiy murojaat va ariza yuborish": {
    ru: "Отправка официального обращения и заявления на имя Ректора",
    en: "Submitting official appeal and application to the Rector"
  },
  "Talabalar turar joyi (TTJ - yotoqxona) uchun ariza topshirish": {
    ru: "Подача заявления на проживание в студенческом общежитии",
    en: "Application for student dormitory accommodation"
  },
  "Nomdor stipendiyalar va tanlovlarda ishtirok etish arizasi": {
    ru: "Заявление на участие в конкурсах на именные стипендии",
    en: "Application for named scholarships and competitions"
  },
  "Talabalar to'garaklari va yoshlar klublariga a'zo bo'lish": {
    ru: "Вступление в студенческие кружки и молодежные клубы",
    en: "Membership in student clubs and youth societies"
  },
  "Doktorantura (DSc, PhD) va stajyor-tadqiqotchilikka qabul arizasi": {
    ru: "Заявление на прием в докторантуру (DSc, PhD) и стажировку-исследование",
    en: "Admission application for doctoral studies (DSc, PhD) and research internship"
  },
  "Maxsus imtihon uchun ariza topshirish": {
    ru: "Подача заявления на специальный экзамен",
    en: "Application for special examination"
  },
  "Korrupsiyaviy holatlar haqida xabar berish (Anonim ishonch telefoni)": {
    ru: "Сообщение о фактах коррупции (Анонимный телефон доверия)",
    en: "Reporting corruption incidents (Anonymous hotline)"
  },
  "Odob-axloq qoidalari buzilishi bo'yicha murojaat": {
    ru: "Обращение по вопросам нарушения норм профессиональной этики",
    en: "Appeal regarding violations of ethical and moral codes"
  },
  "Xalqaro talabalar almashinuv dasturlariga (Erasmus+, Mevlana) ariza": {
    ru: "Заявка на международные программы обмена студентами (Erasmus+, Mevlana)",
    en: "Application for international student exchange programs (Erasmus+, Mevlana)"
  },
  "Xorijiy professor-o'qituvchilar ma'ruzalariga ro'yxatdan o'tish": {
    ru: "Регистрация на лекции зарубежных профессоров и преподавателей",
    en: "Registration for lectures by foreign visiting professors"
  },
  "Ijtimoiy himoyaga muhtoj talaba qizlarga yordam fondi arizasi": {
    ru: "Заявление в фонд помощи социально уязвимым студенткам",
    en: "Application to financial aid fund for vulnerable female students"
  },
  "Ta'lim sifati va darslar samaradorligi bo'yicha anonim so'rovnoma": {
    ru: "Анонимный опрос по качеству образования и эффективности занятий",
    en: "Anonymous survey on educational quality and class effectiveness"
  },
  "Professor-o'qituvchilar faoliyatini talabalar tomonidan baholash": {
    ru: "Оценка деятельности преподавателей студентами",
    en: "Student evaluation of faculty and teaching staff"
  },
  "O'quv rejalari va dasturlari monitoringi takliflarini yuborish": {
    ru: "Отправка предложений по мониторингу учебных планов и программ",
    en: "Submitting suggestions on curriculum and syllabus monitoring"
  },
  "Malakaviy imtihon topshirish yo'riqnomasi": {
    ru: "Инструкция по сдаче квалификационного экзамена",
    en: "Guidelines for taking qualifying examination"
  },
  "Interaktiv xizmatlar portali haqida": {
    ru: "О портале интерактивных услуг",
    en: "About the interactive services portal"
  },
  "Universitet so'rovnomalari": {
    ru: "Университетские опросы",
    en: "University Surveys"
  },
  "Turon universiteti yordam markazi": {
    ru: "Центр помощи Университета Турон",
    en: "Turon University Help Center"
  },
  "Barcha xizmatlar": {
    ru: "Все услуги",
    en: "All Services"
  },
  "Darhol": {
    ru: "Сразу",
    en: "Instant"
  },
  "Onlayn": {
    ru: "Онлайн",
    en: "Online"
  },
  "ball": {
    ru: "баллов",
    en: "pts"
  },
  "ball to'plandi": {
    ru: "баллов набрано",
    en: "points earned"
  },
  "Sinovdan o'ta olmadi": {
    ru: "Не сдан",
    en: "Failed"
  },
  "Muvaffaqiyatli topshirildi": {
    ru: "Успешно сдан",
    en: "Successfully Passed"
  },
  "Hurmatli foydalanuvchi": {
    ru: "Уважаемый пользователь",
    en: "Dear user"
  },
  "Talabgor": {
    ru: "Соискатель",
    en: "Applicant"
  },
  "Administrator": {
    ru: "Администратор",
    en: "Administrator"
  },

  // Topbar
  "O'ZBEKISTON RESPUBLIKASI TA'LIM VA ILM-FAN VAZIRLIGI": {
    ru: "МИНИСТЕРСТВО ОБРАЗОВАНИЯ И НАУКИ РЕСПУБЛИКИ УЗБЕКИСТАН",
    en: "MINISTRY OF EDUCATION AND SCIENCE OF THE REPUBLIC OF UZBEKISTAN"
  },
  "Qarshi sh., Nasaf ko'chasi, 1/14": {
    ru: "г. Карши, ул. Насаф, 1/14",
    en: "Karshi city, Nasaf str., 1/14"
  },
  "Maxsus imkoniyatlar": {
    ru: "Специальные возможности",
    en: "Accessibility"
  },
  "Ko'rish imkoniyati cheklanganlar uchun maxsus rejim": {
    ru: "Специальный режим для слабовидящих",
    en: "Accessibility mode for visually impaired"
  },

  // Navbar
  "INTERAKTIV XIZMATLAR PORTALI": {
    ru: "ПОРТАЛ ИНТЕРАКТИВНЫХ УСЛУГ",
    en: "INTERACTIVE SERVICES PORTAL"
  },
  "Ariza topshirish": {
    ru: "Подать заявку",
    en: "Submit Application"
  },
  "Mening arizalarim": {
    ru: "Мои заявки",
    en: "My Applications"
  },
  "Admin paneli": {
    ru: "Панель администратора",
    en: "Admin Panel"
  },
  "Tizimga kirish": {
    ru: "Вход в систему",
    en: "Log In"
  },
  "Chiqish": {
    ru: "Выйти",
    en: "Log Out"
  },
  "Bildirishnomalar": {
    ru: "Уведомления",
    en: "Notifications"
  },
  "Barchasini o'qilgan deb belgilash": {
    ru: "Отметить все как прочитанные",
    en: "Mark all as read"
  },
  "Yangi bildirishnomalar yo'q": {
    ru: "Нет новых уведомлений",
    en: "No new notifications"
  },
  "Kunduzgi rejimga o'tish (Light mode)": {
    ru: "Дневной режим (Light mode)",
    en: "Day mode (Light mode)"
  },
  "Tungi rejimga o'tish (Dark mode)": {
    ru: "Ночной режим (Dark mode)",
    en: "Night mode (Dark mode)"
  },
  "Kungi va tungi rejimni almashtirish": {
    ru: "Переключить дневной / ночной режим",
    en: "Toggle day / night mode"
  },

  // Accessibility Toolbar
  "Shrift hajmi:": {
    ru: "Размер шрифта:",
    en: "Font Size:"
  },
  "A- Standart": {
    ru: "A- Стандартный",
    en: "A- Standard"
  },
  "A O'rtacha": {
    ru: "A Средний",
    en: "A Medium"
  },
  "A+ Katta": {
    ru: "A+ Большой",
    en: "A+ Large"
  },
  "Rang va kontrast:": {
    ru: "Цвет и контраст:",
    en: "Color & Contrast:"
  },
  "Odatiy": {
    ru: "Обычный",
    en: "Default"
  },
  "Oq-qora": {
    ru: "Черно-белый",
    en: "Monochrome"
  },
  "Yuqori kontrast": {
    ru: "Высокий контраст",
    en: "High Contrast"
  },
  "Sozlamalarni tiklash": {
    ru: "Сбросить настройки",
    en: "Reset Settings"
  },
  "Standart shrift o'lchami (100%)": {
    ru: "Стандартный размер шрифта (100%)",
    en: "Standard font size (100%)"
  },
  "Kattalashtirilgan shrift (115%)": {
    ru: "Увеличенный шрифт (115%)",
    en: "Medium enlarged font (115%)"
  },
  "Katta shrift (130%)": {
    ru: "Крупный шрифт (130%)",
    en: "Large font (130%)"
  },
  "Odatiy rangli rejim": {
    ru: "Обычный цветовой режим",
    en: "Default color mode"
  },
  "Oq-qora (monoxrom) rejim": {
    ru: "Черно-белый (монохромный) режим",
    en: "Black and white monochrome mode"
  },
  "Qora fonda sariq matnli yuqori kontrast rejim": {
    ru: "Высококонтрастный режим: желтый текст на черном фоне",
    en: "High contrast mode: yellow text on black background"
  },
  "Ko'rish imkoniyati cheklanganlar uchun sozlamalar": {
    ru: "Настройки для людей с нарушениями зрения",
    en: "Accessibility settings for visually impaired"
  },

  // Greetings & Weather
  "Xayrli tong": {
    ru: "Доброе утро",
    en: "Good morning"
  },
  "Xayrli kun": {
    ru: "Добрый день",
    en: "Good afternoon"
  },
  "Xayrli oqshom": {
    ru: "Добрый вечер",
    en: "Good evening"
  },
  "Hurmatli talabgor!": {
    ru: "Уважаемый соискатель!",
    en: "Dear Applicant!"
  },
  "Musaffo osmon": {
    ru: "Ясное небо",
    en: "Clear sky"
  },
  "Musaffo tun": {
    ru: "Ясная ночь",
    en: "Clear night"
  },
  "Quyoshli": {
    ru: "Солнечно",
    en: "Sunny"
  },
  "Kam bulutli": {
    ru: "Малооблачно",
    en: "Partly cloudy"
  },
  "Bulutli": {
    ru: "Облачно",
    en: "Cloudy"
  },
  "Yomg'ir": {
    ru: "Дождь",
    en: "Rain"
  },
  "Qor": {
    ru: "Снег",
    en: "Snow"
  },
  "Tuman": {
    ru: "Туман",
    en: "Fog"
  },
  "Harorat:": {
    ru: "Температура:",
    en: "Temperature:"
  },
  "Namlik:": {
    ru: "Влажность:",
    en: "Humidity:"
  },
  "Shamol:": {
    ru: "Ветер:",
    en: "Wind:"
  },

  // Landing Page Hero & Search
  "Turon universiteti interaktiv elektron xizmatlar portali": {
    ru: "Портал интерактивных электронных услуг Университета Турон",
    en: "Turon University Interactive E-Services Portal"
  },
  "Ta'lim, ilmiy izlanishlar va ma'muriy jarayonlar bo'yicha barcha arizalarni onlayn topshiring hamda natijalarini real vaqt rejimida kuzatib boring.": {
    ru: "Подавайте заявки на образовательные, научные и административные услуги онлайн и отслеживайте результаты в режиме реального времени.",
    en: "Submit applications for educational, scientific, and administrative services online and track results in real time."
  },
  "Ariza topshirishni boshlash": {
    ru: "Начать подачу заявки",
    en: "Start Application"
  },
  "Barcha xizmatlar bilan tanishish": {
    ru: "Ознакомиться со всеми услугами",
    en: "Explore All Services"
  },
  "Xizmat nomi yoki kalit so'zni kiriting...": {
    ru: "Введите название услуги или ключевое слово...",
    en: "Enter service name or keyword..."
  },
  "Ommabop qidiruvlar:": {
    ru: "Популярные запросы:",
    en: "Popular searches:"
  },
  "PhD imtihon": {
    ru: "Экзамен PhD",
    en: "PhD exam"
  },
  "Chet tili": {
    ru: "Иностранный язык",
    en: "Foreign language"
  },
  "HEMIS baholar": {
    ru: "Оценки HEMIS",
    en: "HEMIS grades"
  },
  "Korporativ pochta": {
    ru: "Корпоративная почта",
    en: "Corporate email"
  },
  "Qo'shma ta'lim": {
    ru: "Совместное образование",
    en: "Joint education"
  },

  // Public Stats
  "Foydalanuvchilar": {
    ru: "Пользователи",
    en: "Registered Users"
  },
  "Yuborilgan arizalar": {
    ru: "Поданные заявки",
    en: "Submitted Applications"
  },
  "Bo'lim va sektorlar": {
    ru: "Отделы и секторы",
    en: "Departments & Sectors"
  },
  "Interaktiv xizmatlar": {
    ru: "Интерактивные услуги",
    en: "Interactive Services"
  },
  "Qoniqish darajasi": {
    ru: "Уровень удовлетворенности",
    en: "Satisfaction Rate"
  },

  // Departments (11 ta bo'lim)
  "Sohalar bo'yicha xizmatlar": {
    ru: "Услуги по направлениям",
    en: "Services by Department"
  },
  "HEMIS - Oliy ta'lim jarayonlarini boshqarish axborot tizimi": {
    ru: "HEMIS - Информационная система управления процессами высшего образования",
    en: "HEMIS - Higher Education Management Information System"
  },
  "Universitet o'quv-uslubiy kengashi": {
    ru: "Учебно-методический совет университета",
    en: "University Educational and Methodological Council"
  },
  "Universitet kengashi": {
    ru: "Совет университета",
    en: "University Council"
  },
  "Xodimlar bo'limi": {
    ru: "Отдел кадров",
    en: "Human Resources Department"
  },
  "Rektorat - Rektor": {
    ru: "Ректорат - Ректор",
    en: "Rectorate - Rector"
  },
  "Yoshlar bilan ishlash bo'limi": {
    ru: "Отдел по работе с молодежью",
    en: "Youth Affairs Department"
  },
  "Ilmiy bo'lim": {
    ru: "Научный отдел",
    en: "Scientific Department"
  },
  "Korrupsiyaga qarshi kurashish \"Komplayens-nazorat\" tizimini boshqarish bo'limi": {
    ru: "Отдел управления системой «Комплаенс-контроль» по противодействию коррупции",
    en: "Anti-Corruption \"Compliance Control\" System Department"
  },
  "Qo'shma ta'lim dasturlari": {
    ru: "Совместные образовательные программы",
    en: "Joint Educational Programs"
  },
  "Xotin-qizlar bilan ishlash va psixologik maslahat markazi": {
    ru: "Центр по работе с женщинами и психологической консультации",
    en: "Center for Women and Psychological Counseling"
  },
  "Ta'lim sifatini nazorat qilish": {
    ru: "Контроль качества образования",
    en: "Education Quality Control"
  },

  // Service Headings & Tabs
  "Eng ko'p foydalaniladigan xizmatlar": {
    ru: "Самые популярные услуги",
    en: "Most Popular Services"
  },
  "Eng yangi xizmatlar": {
    ru: "Новейшие услуги",
    en: "Newest Services"
  },
  "Barchasi": {
    ru: "Все",
    en: "All"
  },
  "Batafsil ma'lumot": {
    ru: "Подробнее",
    en: "More Information"
  },
  "Batafsil": {
    ru: "Подробнее",
    en: "Details"
  },

  // Services Catalog
  "Chet tilidan va mutaxassislik fanlaridan malakaviy imtihon.": {
    ru: "Квалификационный экзамен по иностранному языку и специальным предметам.",
    en: "Qualifying examination in foreign language and specialty subjects."
  },
  "HEMIS - Talabalar reyting daftarchasi va fan baholarini ko'rish": {
    ru: "HEMIS - Зачетная книжка студентов и просмотр оценок",
    en: "HEMIS - Student Gradebook and Subject Ratings"
  },
  "HEMIS - Dars jadvallari va akademik qarzdorlik ma'lumotnomasi": {
    ru: "HEMIS - Расписание занятий и справка об академической задолженности",
    en: "HEMIS - Class Schedule and Academic Debt Statement"
  },
  "HEMIS - Talaba shaxsiy kabineti parolini tiklash": {
    ru: "HEMIS - Восстановление пароля от личного кабинета студента",
    en: "HEMIS - Student Personal Cabinet Password Recovery"
  },
  "Psixologga murojaat qilish": {
    ru: "Обращение к психологу",
    en: "Consultation with a Psychologist"
  },
  "Professor-o'qituvchilar, tadqiqotchilar va xodimlar uchun korporativ elektron pochta ochish uchun ariza": {
    ru: "Заявка на открытие корпоративной электронной почты для преподавателей, исследователей и сотрудников",
    en: "Application for corporate email for professors, researchers and staff"
  },
  "Xotin-qizlar murojaatini ko'rib chiqish": {
    ru: "Рассмотрение обращений женщин",
    en: "Review of Women's Applications"
  },
  "Pedagog xodimlarni tanlov asosida ishga qabul qilish": {
    ru: "Конкурсный прием на работу педагогических кадров",
    en: "Competitive recruitment of teaching staff"
  },
  "Qo'shma ta'lim qabuli uchun ariza": {
    ru: "Заявление на прием по совместным образовательным программам",
    en: "Application for Joint Education Program Admission"
  },
  "O'quv adabiyotlarni ekspertizadan o'tkazish": {
    ru: "Экспертиза учебной литературы",
    en: "Expertise of Educational Literature"
  },
  "O'quv-uslubiy majmualar va fan sillabuslarini tasdiqlash": {
    ru: "Утверждение учебно-методических комплексов и силлабусов дисциплин",
    en: "Approval of educational complexes and subject syllabi"
  },
  "Ochiq darslar jadvalini muvofiqlashtirish va monitoring": {
    ru: "Координация и мониторинг расписания открытых занятий",
    en: "Coordination and monitoring of open lecture schedule"
  },
  "Ilmiy unvonlar (dotsent, professor) olish uchun Kengash tavsiyanomasi": {
    ru: "Рекомендация Совета на получение ученых званий (доцент, профессор)",
    en: "Council Recommendation for Academic Titles (Associate Professor, Professor)"
  },
  "Universitet Kengashi qarorlaridan ko'chirma olish": {
    ru: "Получение выписки из решений Совета университета",
    en: "Extract from University Council Decisions"
  },
  "Dissertatsiya mavzularini Kengashda tasdiqlash uchun ariza": {
    ru: "Заявка на утверждение тем диссертаций на Совете",
    en: "Application for dissertation topic approval at the Council"
  },
  "Mehnat ta'tili va xizmat safari arizalarini topshirish": {
    ru: "Подача заявлений на трудовой отпуск и служебную командировку",
    en: "Submission of vacation and business trip applications"
  },
  "Ish joyidan ma'lumotnoma (elektron shaklda)": {
    ru: "Справка с места работы (в электронном виде)",
    en: "Certificate of employment (electronic format)"
  },
  "Xodimning mehnat daftarchasidan ko'chirma olish": {
    ru: "Получение выписки из трудовой книжки сотрудника",
    en: "Extract from employee work record book"
  },
  "Rektor qabuliga yozilish (shaxsiy masalalar bo'yicha)": {
    ru: "Запись на прием к ректору (по личным вопросам)",
    en: "Appointment with the Rector (on personal matters)"
  },
  "Universitet rahbariyatiga rasmiy taklif va tashabbuslar yuborish": {
    ru: "Отправка официальных предложений и инициатив руководству университета",
    en: "Sending official proposals and initiatives to university leadership"
  },
  "Talabalar turar joyiga (TTJ) joylashish uchun ariza": {
    ru: "Заявление на заселение в студенческое общежитие",
    en: "Application for Student Dormitory Accommodation"
  },
  "Ijtimoiy yordam va moddiy rag'batlantirish uchun ariza": {
    ru: "Заявление на социальную помощь и материальное стимулирование",
    en: "Application for Social Assistance and Material Incentive"
  },
  "Kutubxona kartasini olish va elektron kutubxonadan foydalanish": {
    ru: "Получение читательского билета и доступ к электронной библиотеке",
    en: "Library Card Registration and Digital Library Access"
  },
  "Korrupsiyaviy holatlar haqida xabar berish (anonim/ochiq)": {
    ru: "Сообщение о коррупционных правонарушениях (анонимно/открыто)",
    en: "Reporting corruption incidents (anonymous/open)"
  },
  "Manfaatlar to'qnashuvi to'g'risida deklaratsiya topshirish": {
    ru: "Подача декларации о конфликте интересов",
    en: "Declaration of Conflict of Interest"
  },
  "Xorijiy hamkor OTM talabalari uchun akademik mobillik arizasi": {
    ru: "Заявка на академическую мобильность для студентов зарубежных вузов-партнеров",
    en: "Academic mobility application for students of foreign partner universities"
  },
  "Xotin-qizlar uchun huquqiy va ijtimoiy yordam so'rash": {
    ru: "Запрос правовой и социальной помощи для женщин",
    en: "Request for Legal and Social Assistance for Women"
  },
  "Talabalar tomonidan o'qitish sifatini baholash so'rovnomasi": {
    ru: "Анкета оценки качества преподавания студентами",
    en: "Student Survey on Teaching Quality Assessment"
  },
  "Dars mashg'ulotlari sifati bo'yicha e'tiroz va shikoyat yuborish": {
    ru: "Подача обращений и жалоб по качеству учебных занятий",
    en: "Submission of feedback and complaints on class quality"
  },

  // Service Detail Page
  "Bosh sahifa": {
    ru: "Главная страница",
    en: "Home"
  },
  "Xizmat tafsilotlari": {
    ru: "Детали услуги",
    en: "Service Details"
  },
  "Qabul muddati yakunlanishiga qoldi:": {
    ru: "До окончания приема документов осталось:",
    en: "Time remaining until application deadline:"
  },
  "kun": {
    ru: "дн",
    en: "days"
  },
  "soat": {
    ru: "час",
    en: "hrs"
  },
  "daqiqa": {
    ru: "мин",
    en: "min"
  },
  "soniya": {
    ru: "сек",
    en: "sec"
  },
  "Qabul muddati yakunlangan": {
    ru: "Прием документов завершен",
    en: "Application deadline passed"
  },
  "Xizmat ko'rsatish muddati:": {
    ru: "Срок оказания услуги:",
    en: "Processing Time:"
  },
  "Xizmat narxi:": {
    ru: "Стоимость услуги:",
    en: "Service Fee:"
  },
  "BHMning 1 baravari": {
    ru: "1 БРВ (Базовая расчетная величина)",
    en: "1 BRV (Base Calculation Amount)"
  },
  "BHMning 1 baravari (Begona OTM talabgorlari uchun), Turon universiteti tadqiqotchilari uchun bepul": {
    ru: "1 БРВ (для соискателей из других вузов), бесплатно для исследователей Университета Турон",
    en: "1 BRV (for external applicants), free of charge for Turon University researchers"
  },
  "Kerakli hujjatlar:": {
    ru: "Необходимые документы:",
    en: "Required Documents:"
  },
  "Arizani ko'rib chiqish bosqichlari:": {
    ru: "Этапы рассмотрения заявки:",
    en: "Application Review Stages:"
  },
  "1. Hujjatlarni topshirish va to'lov kvitansiyasini yuklash": {
    ru: "1. Подача документов и загрузка квитанции об оплате",
    en: "1. Document submission and receipt upload"
  },
  "2. Mutaxassislar tomonidan ekspertizadan o'tkazish": {
    ru: "2. Экспертиза представленных документов специалистами",
    en: "2. Expert verification of submitted documents"
  },
  "3. Imtihon ruxsatnomasi va sanasini belgilash": {
    ru: "3. Назначение даты экзамена и выдача пропуска",
    en: "3. Exam date scheduling and permit issuance"
  },
  "4. Imtihon topshirish va rasmiy qaydnomani olish": {
    ru: "4. Сдача экзамена и получение официальной ведомости",
    en: "4. Taking examination and obtaining official transcript"
  },
  "Arizani hoziroq yuborish": {
    ru: "Подать заявку сейчас",
    en: "Submit Application Now"
  },
  "Bank rekvizitlari va to'lov tartibi": {
    ru: "Банковские реквизиты и порядок оплаты",
    en: "Bank Requisites & Payment Guide"
  },
  "Talabgorlar sharhlari va baholari": {
    ru: "Отзывы и оценки соискателей",
    en: "Applicant Reviews & Ratings"
  },
  "Sharh qoldirish": {
    ru: "Оставить отзыв",
    en: "Leave a Review"
  },
  "Hali sharhlar mavjud emas. Birinchi bo'lib sharh qoldiring!": {
    ru: "Отзывов пока нет. Будьте первым, кто оставит отзыв!",
    en: "No reviews yet. Be the first to leave a review!"
  },
  "Baholash (1 dan 5 gacha):": {
    ru: "Оценка (от 1 до 5):",
    en: "Rating (1 to 5):"
  },
  "Fikringiz yoki taklifingiz:": {
    ru: "Ваш отзыв или предложение:",
    en: "Your review or suggestions:"
  },
  "Yuborish": {
    ru: "Отправить",
    en: "Submit"
  },
  "Bekor qilish": {
    ru: "Отмена",
    en: "Cancel"
  },

  // Registration Form Wizard
  "Talabgor ro'yxatdan o'tish varaqasi": {
    ru: "Регистрационная анкета соискателя",
    en: "Applicant Registration Form"
  },
  "1. Shaxsiy ma'lumotlar": {
    ru: "1. Личные данные",
    en: "1. Personal Information"
  },
  "2. Mutaxassislik va hujjatlar": {
    ru: "2. Специальность и документы",
    en: "2. Specialization & Documents"
  },
  "3. To'lov va tasdiqlash": {
    ru: "3. Оплата и подтверждение",
    en: "3. Payment & Confirmation"
  },
  "F.I.SH (To'liq ism-sharifingiz)": {
    ru: "Ф.И.О. (Полное имя)",
    en: "Full Name"
  },
  "Pasport yoki ID-karta seriyasi va raqami": {
    ru: "Серия и номер паспорта / ID-карты",
    en: "Passport or ID-card serial & number"
  },
  "Tug'ilgan sana": {
    ru: "Дата рождения",
    en: "Date of Birth"
  },
  "Telefon raqamingiz": {
    ru: "Номер телефона",
    en: "Phone Number"
  },
  "Elektron pochta manzili": {
    ru: "Адрес электронной почты",
    en: "Email Address"
  },
  "Ish yoki o'qish joyi (OTM nomi)": {
    ru: "Место работы или учебы (Наименование вуза)",
    en: "Institution / University Name"
  },
  "Lavozimi va ilmiy darajasi (unvoni)": {
    ru: "Должность и ученая степень (звание)",
    en: "Position and Academic Degree"
  },
  "Imtihon topshiriladigan fan yoki ixtisoslik": {
    ru: "Предмет или специальность для сдачи экзамена",
    en: "Exam Subject or Specialization"
  },
  "Dissertatsiya mavzusi": {
    ru: "Тема диссертации",
    en: "Dissertation Topic"
  },
  "Ilmiy rahbar (maslahatchi) F.I.SH": {
    ru: "Ф.И.О. научного руководителя (консультанта)",
    en: "Scientific Advisor Full Name"
  },
  "Hujjatlarni yuklash (PDF yoki rasm ko'rinishida)": {
    ru: "Загрузка документов (в формате PDF или изображения)",
    en: "Upload Documents (PDF or Image format)"
  },
  "Pasport / ID-karta nusxasi": {
    ru: "Копия паспорта / ID-карты",
    en: "Copy of Passport / ID-card"
  },
  "Oliy ma'lumot to'g'risidagi diplom nusxasi": {
    ru: "Копия диплома о высшем образовании",
    en: "Copy of Higher Education Diploma"
  },
  "Kafedra / Kengash tavsiyanomasi": {
    ru: "Рекомендация кафедры / Совета",
    en: "Department / Council Recommendation"
  },
  "To'lov kvitansiyasi (BHM 1 baravari)": {
    ru: "Квитанция об оплате (1 БРВ)",
    en: "Payment Receipt (1 BRV)"
  },
  "Oldingi": {
    ru: "Назад",
    en: "Previous"
  },
  "Keyingi bosqich": {
    ru: "Следующий шаг",
    en: "Next Step"
  },
  "Arizani tasdiqlash va yuborish": {
    ru: "Подтвердить и отправить заявку",
    en: "Confirm & Submit Application"
  },
  "Yuborilmoqda...": {
    ru: "Отправка...",
    en: "Submitting..."
  },
  "Fayl tanlang": {
    ru: "Выберите файл",
    en: "Choose file"
  },
  "Fayl yuklandi": {
    ru: "Файл загружен",
    en: "File uploaded"
  },
  "Fan yoki ixtisoslikni tanlang...": {
    ru: "Выберите предмет или специальность...",
    en: "Select subject or specialization..."
  },
  "Qidirish...": {
    ru: "Поиск...",
    en: "Search..."
  },

  // Login & Registration Pages
  "Hisobingizga kiring": {
    ru: "Вход в личный кабинет",
    en: "Log in to your account"
  },
  "Login yoki Email": {
    ru: "Логин или Email",
    en: "Login or Email"
  },
  "Parol": {
    ru: "Пароль",
    en: "Password"
  },
  "Parolni unutdim": {
    ru: "Забыли пароль?",
    en: "Forgot password?"
  },
  "Bu qurilmada meni eslab qoling": {
    ru: "Запомнить меня на этом устройстве",
    en: "Remember me on this device"
  },
  "Kirish": {
    ru: "Войти",
    en: "Log In"
  },
  "Tekshirilmoqda...": {
    ru: "Проверка...",
    en: "Verifying..."
  },
  "YOKI": {
    ru: "ИЛИ",
    en: "OR"
  },
  "Google orqali kirish": {
    ru: "Войти через Google",
    en: "Sign in with Google"
  },
  "OneID orqali kirish": {
    ru: "Войти через OneID",
    en: "Sign in with OneID"
  },
  "Hali hisobingiz yo'qmi?": {
    ru: "У вас еще нет учетной записи?",
    en: "Don't have an account yet?"
  },
  "Ro'yxatdan o'tish": {
    ru: "Регистрация",
    en: "Register"
  },
  "Yangi hisob yaratish": {
    ru: "Создание нового аккаунта",
    en: "Create New Account"
  },
  "Familiya, ism, sharifingiz": {
    ru: "Фамилия, имя, отчество",
    en: "Full name (Last, First, Middle)"
  },
  "F.I.SH (To'liq ism-sharifingizni kiriting)": {
    ru: "Ф.И.О. (Введите полное имя)",
    en: "Full Name (Enter your full name)"
  },
  "Elektron pochtangizni kiriting": {
    ru: "Введите ваш адрес электронной почты",
    en: "Enter your email address"
  },
  "Parol o'ylab toping": {
    ru: "Придумайте пароль",
    en: "Create a password"
  },
  "Parolni tasdiqlang": {
    ru: "Подтвердите пароль",
    en: "Confirm password"
  },
  "Foydalanish shartlari va Maxfiylik siyosatiga roziman": {
    ru: "Я согласен с Условиями использования и Политикой конфиденциальности",
    en: "I agree to the Terms of Service and Privacy Policy"
  },
  "(Batafsil)": {
    ru: "(Подробнее)",
    en: "(Details)"
  },
  "Hisob yaratish": {
    ru: "Создать аккаунт",
    en: "Create Account"
  },
  "Elektron pochtangizni tasdiqlang": {
    ru: "Подтвердите ваш адрес электронной почты",
    en: "Verify your email address"
  },
  "Tasdiqlash kodi": {
    ru: "Код подтверждения",
    en: "Verification Code"
  },
  "Tasdiqlash va faollashtirish": {
    ru: "Подтвердить и активировать",
    en: "Verify and Activate"
  },
  "Kodni qayta yuborish": {
    ru: "Отправить код повторно",
    en: "Resend Code"
  },
  "Elektron pochtangiz hali tasdiqlanmagan": {
    ru: "Ваша электронная почта еще не подтверждена",
    en: "Your email is not verified yet"
  },
  "Kodni kiritish va faollashtirish →": {
    ru: "Ввести код и активировать →",
    en: "Enter code and activate →"
  },
  "Xatni qayta yuborish": {
    ru: "Отправить письмо повторно",
    en: "Resend verification email"
  },
  "Login sahifasiga qaytish": {
    ru: "Вернуться на страницу входа",
    en: "Return to login page"
  },

  // Applicant Dashboard
  "Shaxsiy kabinet": {
    ru: "Личный кабинет",
    en: "Applicant Dashboard"
  },
  "Arizani chop etish": {
    ru: "Распечатать заявление",
    en: "Print Application"
  },
  "Ma'lumotlarni yangilash": {
    ru: "Обновить данные",
    en: "Refresh Data"
  },
  "Ariza va imtihon bosqichlari monitoringi": {
    ru: "Мониторинг этапов заявки и экзамена",
    en: "Application & Examination Progress Monitoring"
  },
  "1. Ariza yuborildi": {
    ru: "1. Заявка отправлена",
    en: "1. Application Submitted"
  },
  "2. Hujjatlar ekspertizasi": {
    ru: "2. Экспертиза документов",
    en: "2. Document Verification"
  },
  "3. Imtihon ruxsati": {
    ru: "3. Допуск к экзамену",
    en: "3. Exam Permission"
  },
  "4. Offline imtihon va natija": {
    ru: "4. Очный экзамен и результат",
    en: "4. Offline Exam & Result"
  },
  "Hujjatlar topshirildi": {
    ru: "Документы поданы",
    en: "Documents submitted"
  },
  "Tekshiruv jarayonida": {
    ru: "В процессе проверки",
    en: "Under review"
  },
  "Kutilmoqda": {
    ru: "Ожидается",
    en: "Pending"
  },
  "Qabul qilindi": {
    ru: "Принято",
    en: "Approved"
  },
  "Rad etildi": {
    ru: "Отклонено",
    en: "Rejected"
  },
  "Tasdiqlandi ✓": {
    ru: "Подтверждено ✓",
    en: "Confirmed ✓"
  },
  "Offline sana belgilandi": {
    ru: "Назначена дата очного экзамена",
    en: "Offline date scheduled"
  },
  "Ruxsat berilgan": {
    ru: "Допуск разрешен",
    en: "Permission granted"
  },
  "Ruxsat kutilmoqda": {
    ru: "Ожидается допуск",
    en: "Waiting for permission"
  },
  "OFFLINE MALAKAVIY IMTIHON NATIJASI": {
    ru: "РЕЗУЛЬТАТ ОЧНОГО КВАЛИФИКАЦИОННОГО ЭКЗАМЕНА",
    en: "OFFLINE QUALIFYING EXAM RESULT"
  },
  "Tabriklaymiz! Malakaviy imtihon sinovidan muvaffaqiyatli o'tdingiz": {
    ru: "Поздравляем! Вы успешно сдали квалификационный экзамен",
    en: "Congratulations! You have successfully passed the qualifying examination"
  },
  "Malakaviy imtihon sinovidan o'tish bali to'planmadi": {
    ru: "Проходной балл квалификационного экзамена не набран",
    en: "Qualifying examination passing score was not reached"
  },
  "Turon universiteti malakaviy imtihon komissiyasi rasmiy qaydnomasi": {
    ru: "Официальная ведомость экзаменационной комиссии Университета Турон",
    en: "Official record of Turon University qualifying exam commission"
  },
  "Arizani tahrirlash va qayta yuborish": {
    ru: "Редактировать и отправить повторно",
    en: "Edit & Resubmit Application"
  },
  "Ma'muriyatdan xabarnoma: Arizangizni tahrirlashingiz mumkin": {
    ru: "Уведомление от администрации: вы можете отредактировать заявку",
    en: "Notice from administration: You may edit your application"
  },
  "Arizangiz yoki yuklangan hujjatlaringizda kamchiliklar aniqlangani sababli ma'muriyat tomonidan tahrirlash imkoniyati ochildi.": {
    ru: "В вашей заявке или документах обнаружены замечания, администрация предоставила возможность редактирования.",
    en: "Discrepancies were identified in your application or documents; the administration has opened edit access."
  },
  "Admin ko'rsatmasi:": {
    ru: "Указание администратора:",
    en: "Admin instruction:"
  },
  "Yo'llanma varaqasini yuklab olish (PDF)": {
    ru: "Скачать пропускной лист (PDF)",
    en: "Download Admission Voucher (PDF)"
  },
  "To'lov holati:": {
    ru: "Статус оплаты:",
    en: "Payment Status:"
  },
  "To'langan ✓": {
    ru: "Оплачено ✓",
    en: "Paid ✓"
  },
  "To'lanmagan": {
    ru: "Не оплачено",
    en: "Not Paid"
  },

  // Admin Dashboard
  "Administrator boshqaruv paneli": {
    ru: "Панель управления администратора",
    en: "Administrator Control Panel"
  },
  "Kelib tushgan arizalar": {
    ru: "Поступившие заявки",
    en: "Incoming Applications"
  },
  "Tasdiqlanganlar": {
    ru: "Подтвержденные",
    en: "Approved"
  },
  "Kutilayotganlar": {
    ru: "Ожидающие",
    en: "Pending"
  },
  "Rad etilganlar": {
    ru: "Отклоненные",
    en: "Rejected"
  },
  "Filtrlash:": {
    ru: "Фильтрация:",
    en: "Filter:"
  },
  "Eksport (Excel)": {
    ru: "Экспорт (Excel)",
    en: "Export (Excel)"
  },
  "Ball qo'yish": {
    ru: "Выставить балл",
    en: "Assign Score"
  },
  "Tasdiqlash": {
    ru: "Подтвердить",
    en: "Approve"
  },
  "Rad etish": {
    ru: "Отклонить",
    en: "Reject"
  },
  "Hujjatlarni ko'rish": {
    ru: "Просмотр документов",
    en: "View Documents"
  },

  // Footer
  "Turon universiteti tomonidan taqdim etiladigan barcha ta'lim, ilmiy va elektron xizmatlardan onlayn foydalanish, arizalar yuborish hamda natijalarni monitoring qilishning yagona interaktiv axborot portali.": {
    ru: "Единый интерактивный информационный портал Университета Турон для онлайн-доступа к образовательным, научным и электронным услугам, подачи заявок и мониторинга результатов.",
    en: "Unified interactive information portal of Turon University for online access to all educational, scientific, and electronic services, application submissions, and results monitoring."
  },
  "Asosiy havolalar": {
    ru: "Основные ссылки",
    en: "Quick Links"
  },
  "Malakaviy imtihon xizmati": {
    ru: "Услуга квалификационного экзамена",
    en: "Qualifying Exam Service"
  },
  "Rasmiy veb-sayt": {
    ru: "Официальный веб-сайт",
    en: "Official Website"
  },
  "Bog'lanish va manzil": {
    ru: "Контакты и адрес",
    en: "Contact & Address"
  },
  "Qashqadaryo viloyati, Qarshi shahri, Nasaf ko'chasi, 1/14-uy": {
    ru: "Кашкадарьинская область, г. Карши, ул. Насаф, 1/14",
    en: "Kashkadarya region, Karshi city, Nasaf str., 1/14"
  },
  "© 2026 Turon universiteti. Barcha huquqlar himoyalangan.": {
    ru: "© 2026 Университет Турон. Все права защищены.",
    en: "© 2026 Turon University. All rights reserved."
  },
  "Dasturchi": {
    ru: "Разработчик",
    en: "Developer"
  },
  "Dasturchi bilan bog'lanish": {
    ru: "Связаться с разработчиком",
    en: "Contact Developer"
  },

  // Verify Voucher & Exam Page
  "Turon universiteti rasmiy bazasidan yo'llanma ma'lumotlari tekshirilmoqda...": {
    ru: "Проверка данных пропуска в официальной базе Университета Турон...",
    en: "Verifying voucher data from Turon University official database..."
  },
  "Yo'llanma tasdiqlanmadi": {
    ru: "Пропуск не подтвержден",
    en: "Voucher not verified"
  },
  "Bosh sahifaga qaytish": {
    ru: "Вернуться на главную",
    en: "Return to Home"
  },
  "Savol": {
    ru: "Вопрос",
    en: "Question"
  },
  "Keyingi": {
    ru: "Следующий",
    en: "Next"
  },
  "Yakunlash": {
    ru: "Завершить",
    en: "Finish"
  },
  "Qolgan vaqt:": {
    ru: "Оставшееся время:",
    en: "Time Remaining:"
  },

  // Modal Dialogs & General UI
  "Yopish": {
    ru: "Закрыть",
    en: "Close"
  },
  "Saqlash": {
    ru: "Сохранить",
    en: "Save"
  },
  "Yuklanmoqda...": {
    ru: "Загрузка...",
    en: "Loading..."
  },
  "Muvaffaqiyatli bajarildi!": {
    ru: "Успешно выполнено!",
    en: "Completed successfully!"
  },
  "Xatolik yuz berdi": {
    ru: "Произошла ошибка",
    en: "An error occurred"
  },
  "Murojaat va texnik masalalar bo'yicha aloqa:": {
    ru: "Контакты по обращениям и техническим вопросам:",
    en: "Contact for inquiries and technical issues:"
  },
  "Qarshi shahri, Nasaf ko'chasi, 1/14-uy": {
    ru: "г. Карши, ул. Насаф, 1/14",
    en: "Karshi city, Nasaf str., 1/14"
  },
  "so'rovi bo'yicha jami": {
    ru: "всего по запросу",
    en: "in total for query"
  },
  "ta xizmat va bo'lim topildi.": {
    ru: "услуг и отделов найдено.",
    en: "services and departments found."
  },
  "Qidiruvni tozalash": {
    ru: "Очистить поиск",
    en: "Clear search"
  },
  "so'rovi bo'yicha hech qanday xizmat topilmadi": {
    ru: "по данному запросу никаких услуг не найдено",
    en: "no services found for this query"
  },
  "Barcha xizmatlarni ko'rsatish": {
    ru: "Показать все услуги",
    en: "Show all services"
  },
  "Xizmat yoki bo'lim nomini qidiring (masalan: HEMIS, Imtihon, Rektorat, Psixolog)...": {
    ru: "Поиск услуги или отдела (например: HEMIS, Экзамен, Ректорат, Психолог)...",
    en: "Search for service or department (e.g., HEMIS, Exam, Rectorate, Psychologist)..."
  },
  "Arizalarni ko'rish uchun tizimga kiring.": {
    ru: "Для просмотра заявлений войдите в систему.",
    en: "Please log in to view applications."
  },
  "Malakaviy imtihon arizasini topshirish uchun avval tizimga kiring.": {
    ru: "Для подачи заявления на квалификационный экзамен сначала войдите в систему.",
    en: "Please log in to apply for the qualifying examination."
  },
  "Talabgor sifatida tizimga kiring yoki ro'yxatdan o'ting.": {
    ru: "Войдите в систему или зарегистрируйтесь как соискатель.",
    en: "Log in or register as an applicant."
  },
  "Bahoyingiz va sharhingiz muvaffaqiyatli qabul qilindi!": {
    ru: "Ваша оценка и отзыв успешно приняты!",
    en: "Your rating and review have been successfully accepted!"
  },
  "Admin boshqaruv paneliga qaytish": {
    ru: "Вернуться в панель администратора",
    en: "Return to Admin Panel"
  },
  "Hozircha bildirishnomalar mavjud emas": {
    ru: "Пока нет уведомлений",
    en: "No notifications yet"
  },
  "Barchasini o'qilgan qilish": {
    ru: "Отметить все как прочитанные",
    en: "Mark all as read"
  },
  "Barcha arizalarim va monitoring": {
    ru: "Все мои заявления и мониторинг",
    en: "All my applications and monitoring"
  },
  "Portal administratori": {
    ru: "Администратор портала",
    en: "Portal Administrator"
  },
  "Call-markaz:": {
    ru: "Колл-центр:",
    en: "Call Center:"
  },
  "Kunduzgi": {
    ru: "Светлая",
    en: "Light"
  },
  "Tungi": {
    ru: "Темная",
    en: "Dark"
  },
  "Ariza №": {
    ru: "Заявление №",
    en: "Application No."
  },
  "Mening kabinetim": {
    ru: "Мой кабинет",
    en: "My Cabinet"
  },
  "Yaqinda": {
    ru: "Недавно",
    en: "Recently"
  },
  "ta yangi": {
    ru: "новых",
    en: "new"
  },
  "Barcha huquqlar himoyalangan.": {
    ru: "Все права защищены.",
    en: "All rights reserved."
  },
  "Jami:": {
    ru: "Всего:",
    en: "Total:"
  },
  "Tozalash": {
    ru: "Очистить",
    en: "Clear"
  }
};

// Fast lookup maps indexed by normalized string
const lookupRu = new Map();
const lookupEn = new Map();

for (const [key, trans] of Object.entries(PHRASES)) {
  const norm = normalizeKey(key);
  if (norm) {
    if (trans.ru) lookupRu.set(norm, trans.ru);
    if (trans.en) lookupEn.set(norm, trans.en);
  }
}

// Regex patterns for dynamic numbers and units
export function translateDynamicPatterns(text, lang) {
  if (!text || typeof text !== 'string') return text;
  if (lang === 'uz') return toNewLatin(text);

  let res = text;

  if (lang === 'ru') {
    // X kun
    res = res.replace(/(\d+)\s+kun\b/gi, '$1 дней');
    // 1 kun
    res = res.replace(/\b1\s+дней\b/gi, '1 день');
    res = res.replace(/\b([234])\s+дней\b/gi, '$1 дня');
    // X daqiqa
    res = res.replace(/(\d+)\s+daqiqa\b/gi, '$1 минут');
    res = res.replace(/\b1\s+минут\b/gi, '1 минута');
    res = res.replace(/\b([234])\s+минут\b/gi, '$1 минуты');
    // X soat
    res = res.replace(/(\d+)\s+soat\b/gi, '$1 часов');
    res = res.replace(/\b1\s+часов\b/gi, '1 час');
    res = res.replace(/\b([234])\s+часов\b/gi, '$1 часа');
    // X soniya
    res = res.replace(/(\d+)\s+soniya\b/gi, '$1 секунд');
    // X ball
    res = res.replace(/(\d+)\s+ball\b/gi, '$1 баллов');
    // Harorat / Namlik / Shamol
    res = res.replace(/^Harorat:\s*/i, 'Температура: ');
    res = res.replace(/^Namlik:\s*/i, 'Влажность: ');
    res = res.replace(/^Shamol:\s*/i, 'Ветер: ');
    // Dates
    res = res.replace(/(\d{4})-yil\s+(\d{1,2})-oktabrdan\s+(\d{1,2})-oktabrgacha/gi, 'С $2 по $3 октября $1 года');
  } else if (lang === 'en') {
    // X kun
    res = res.replace(/(\d+)\s+kun\b/gi, '$1 days');
    res = res.replace(/\b1\s+days\b/gi, '1 day');
    // X daqiqa
    res = res.replace(/(\d+)\s+daqiqa\b/gi, '$1 min');
    // X soat
    res = res.replace(/(\d+)\s+soat\b/gi, '$1 hrs');
    res = res.replace(/\b1\s+hrs\b/gi, '1 hr');
    // X soniya
    res = res.replace(/(\d+)\s+soniya\b/gi, '$1 sec');
    // X ball
    res = res.replace(/(\d+)\s+ball\b/gi, '$1 pts');
    // Harorat / Namlik / Shamol
    res = res.replace(/^Harorat:\s*/i, 'Temperature: ');
    res = res.replace(/^Namlik:\s*/i, 'Humidity: ');
    res = res.replace(/^Shamol:\s*/i, 'Wind: ');
    // Dates
    res = res.replace(/(\d{4})-yil\s+(\d{1,2})-oktabrdan\s+(\d{1,2})-oktabrgacha/gi, 'From Oct $2 to Oct $3, $1');
  }

  return res;
}

// Translate a given text string into the desired language
export function translateText(text, lang) {
  if (!text || typeof text !== 'string') return text;
  if (lang === 'uz') {
    return toNewLatin(text);
  }

  const norm = normalizeKey(text);
  const targetMap = lang === 'ru' ? lookupRu : lookupEn;

  if (targetMap.has(norm)) {
    return targetMap.get(norm);
  }

  // Check dynamic patterns
  return translateDynamicPatterns(text, lang);
}
